import { Navigate } from "react-router-dom";
import { PageContent } from "../../../assets/layouts";
import { ClaimHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { useCommunity } from "../../../context/communityContext";
import { CommunityService } from "../communityService";
import { CommunityNeighborhoodContainer } from "./communityNeighborhoodContainer";

export const CommunityNeighborhoodSettings = () => {
  const { communityId: selectedCommunityId } = useCommunity();
  const userCommunitiesQuery = CommunityService.getUserCommunities();
  const singleCommunityId =
    userCommunitiesQuery.data?.length === 1
      ? userCommunitiesQuery.data[0].communityId
      : undefined;
  const communityId =
    singleCommunityId ??
    selectedCommunityId ??
    ClaimHelper.getCommunityId() ??
    Constants.emptyGuid;
  const lookupQuery = CommunityService.getLookups();

  if (communityId === Constants.emptyGuid) {
    return <Navigate to="/adminsettings" replace />;
  }

  return (
    <PageContent hideHeader>
      <CommunityNeighborhoodContainer
        communityId={communityId}
        isCommunityDeactive={false}
        counties={lookupQuery.data?.county}
      />
    </PageContent>
  );
};
